module.exports = __webpack_public_path__ + "img/spin_btn.33727b69.png";